import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { keyframes } from "@emotion/react";

//Components
import SideBar from "../../components/Sidebar/Sidebar";

import { getLink } from "../../store/ducks/promoteLink/actions";
import { isDesktop } from "react-device-detect";
import MobilePromoteLink from "./MobilePromoteLink";
import domainJson from "../../common/data/domain.json";

class PromoteLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      promote_link_member: '',
      promote_link_agent: ''
    };
    this.linkRef = createRef();
  }

  componentDidMount() {
    this.props.getLink();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.get_link !== undefined && nextProps.get_link !== this.props.get_link) {
      if (nextProps.get_link.responseCode === 200 && nextProps.get_link.msgType === 'success') {
        let promote_link_member = "";
        let promote_link_agent = "";
        let agent_country = nextProps.get_link.data.agentLink.country.toLowerCase();
        let referralCode = nextProps.get_link.data.agentLink.referralCode;
        let countries = Object.assign({}, domainJson);
        
        // Generate member promote link
        if (process.env.REACT_APP_ENV === "staging") {
          promote_link_member = countries[agent_country]['staging_promote_domain'] + '/?refCode=' + referralCode;
        } else {
          promote_link_member = countries[agent_country]['live_promote_domain'] + '/?refCode=' + referralCode;
        }
        
        // Generate agent/affiliate promote link
        if (process.env.REACT_APP_ENV === "staging") {
          promote_link_agent = countries[agent_country]['staging_affiliate_promote_domain'] + '/?refCode=' + referralCode;
        } else {
          promote_link_agent = countries[agent_country]['live_affiliate_promote_domain'] + '/?refCode=' + referralCode;
        }

        this.setState({
          data: nextProps.get_link.data,
          loading: false,
          promote_link_member: promote_link_member,
          promote_link_agent: promote_link_agent
        });
      }
    }

    return true;
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  copyToClipboardHandler = event => {
    this.linkRef.current.select();
    document.execCommand("copy");
  }

  render() {
    const { t } = this.props;
    const currency = this.props.currentUser.data.currency;
    const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));

    const fadeUp = keyframes`
      from {
        opacity: 0;
        transform: translate3d(0, 50px ,0);
      }

      to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    `;

    return (
      <Auxiliary>
        {
          isDesktop ? (
            <>
              <section className="pf-dashboard">
                <div className="x-container">
                  <SideBar />
                  <div className="row">
                    <div className="db-col col-12">
                      <div className="pd-card-col">
                        <h4>{t("promote-link.promote-link")}</h4>
                        <div className="pd-content">
                          <div className='row'>
                            <div className='col-12'>
                              <div className="card-shadow p-3">
                                <div className="mb-1">
                                  {t("promote-link.member-title")}
                                </div>
                                <div className="input-group right">
                                    <input
                                      ref={this.linkRef}
                                      type="text"
                                      className="form-control"
                                      name="referCode"
                                      defaultValue={this.state.promote_link_member}
                                      readOnly
                                    />
                                    <span className="input-group-text">
                                      <button type="button" className="btn btn-gradient-blue" onClick={(event) => this.copyToClipboardHandler(event)}>
                                        {t("promote-link.copy")}
                                      </button>
                                    </span>
                                </div>
                              </div>

                              <div className="card-shadow p-3">
                                <div className="mb-1">
                                  {t("promote-link.agent-title")}
                                </div>
                                <div className="input-group right">
                                    <input
                                      ref={this.linkRef}
                                      type="text"
                                      className="form-control"
                                      name="referCode"
                                      defaultValue={this.state.promote_link_agent}
                                      readOnly
                                    />
                                    <span className="input-group-text">
                                      <button type="button" className="btn btn-gradient-blue" onClick={(event) => this.copyToClipboardHandler(event)}>
                                        {t("promote-link.copy")}
                                      </button>
                                    </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          ) : (
            <MobilePromoteLink
              icons={icons}
              currency={currency}

              {...this.props}
              {...this.state}
            />
          )
        }
      </Auxiliary>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentUser: state.currentUser,
    get_link: state.promoteLink.get_link
  }
}

const mapDispatchToProps = {
  getLink
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(PromoteLink));
